import { useTheme } from 'styled-components';

import { Informer } from '@/ui/Informer';
import { formatFutureCountdown } from '@/utils/dates';

export type UpNextAllItemsLockedInformerProps = {
  /** Next unlock time */
  unlockAt?: Date | string;
};

export const UpNextAllItemsLockedInformer = ({ unlockAt }: UpNextAllItemsLockedInformerProps): JSX.Element => {
  const theme = useTheme();
  const parsed = unlockAt !== undefined && unlockAt !== null ? new Date(unlockAt) : new Date();
  const target = Number.isFinite(parsed.getTime()) ? parsed : new Date();
  const usedExplicitUnlock = unlockAt !== undefined && unlockAt !== null && Number.isFinite(new Date(unlockAt).getTime());
  const fromDate = new Date();
  const relative = formatFutureCountdown(fromDate, target, {
    includeTimeIfTomorrow: usedExplicitUnlock,
  });
  const label = `You're all set for now. Your next item unlocks ${relative}.`;

  return (
    <Informer
      label={label}
      sideBox={{
        background: theme.colors.success.container,
        icon: ['far', 'circle-check'],
        iconColor: theme.colors.success.onContainer,
      }}
    />
  );
};
